export const c = (...args) => args.filter(Boolean).join(' ');
